import React from "react";

import {
    FaRobot,
    FaCheckCircle
} from "react-icons/fa";


class DashboardHeader extends React.Component {


    render(){


        const {

            userName = "Trader",

            subscription = "Professional",

            aiStatus = "Online"

        } = this.props;



        const aiOnline =
            aiStatus === "Online";



        return (

            <div className="dashboard-header-wrapper">


                <div className="idms-card">


                    <div className="card-header">


                        <div>


                            <h1 className="card-title">

                                Welcome back, {userName}

                            </h1>


                            <p className="card-subtitle">

                                iDMS Cloud-based Trading Intelligence Platform

                            </p>


                        </div>



                        <div className="header-status">


                            <FaRobot
                                className="header-icon"
                            />


                            <div>


                                <span className="status-label">

                                    AI Engine

                                </span>



                                <div
                                    className={
                                        aiOnline
                                        ?
                                        "ai-status online"
                                        :
                                        "ai-status offline"
                                    }
                                >


                                    <FaCheckCircle />


                                    {aiStatus}


                                </div>


                            </div>


                        </div>



                    </div>



                    <div className="header-plan">


                        <span>

                            Current Plan

                        </span>


                        <strong>

                            {subscription}

                        </strong>


                    </div>



                </div>


            </div>

        );


    }


}


export default DashboardHeader;